import Echo from 'laravel-echo';
import { PUSHER_KEY, PUSHER_WS_HOST, PUSHER_AUTH_ENDPOINT } from '../config';

const host = PUSHER_WS_HOST;
const key = PUSHER_KEY;

let connection: Echo | null = null;

export { connection };

export default async () => {
  try {
    if (connection) return connection;

    await import('pusher-js');

    const wsHost = host.replace(/(^\w+:|^)\/\//, '');

    const socketParams = {
      broadcaster: 'pusher',
      host,
      encrypted: true,
      namespace: 'App.Events',
      forceTLS: false,
      wsHost,
      key,
      authEndpoint: `${host}${PUSHER_AUTH_ENDPOINT}`,
      cluster: 'eu',
    };

    connection = new Echo(socketParams);

    return connection;
  } catch (e) {
    return Promise.reject();
  }
};

export const getTicketsChannel = (userId: string, hash: string) =>
  `support.workflow.${userId}.${hash}`;
